<template>
  <section class="panel panel-default">
    <div class="modal-body" style="height:60vh;width:850px;margin:0 auto;overflow:auto;">
    
      <vue-html2pdf
        :show-layout="false"
        :float-layout="false"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="8100"
        :filename="lpoNumber"
        :pdf-quality="2"
        :pdf-margin="20"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="portrait"
        pdf-content-width="800px"
        :htmlToPdfOptions="htmlToPdfOptions"
        ref="html2Pdf"
    >
        <section slot="pdf-content">
          <purchase-order :purchaseId="purchaseId" :item="item" :cartItems="cartItems" :lpoStatus="lpoStatus"
          :showTerms="showTerms" :showVAT="includeVAT" />
        </section>
    </vue-html2pdf>
    <!--
      <div id="print">
        <div class="row page-header">
          <div class="col-xs-6">
            <img src="../../public/static/img/logo.png"/>
          </div>
          <div class="col-xs-6">
            <table style="float: right;font-size: 13px;">
              <tr>
                <td style="padding-right:10px;font-weight: bold;">PO NUMBER</td>
                <td>{{lpoNumber}}</td>
              </tr>
              <tr>
                <td style="padding-right:10px;font-weight: bold;">PO DATE</td>
                <td>{{orderDate | dateFormat}}</td>
              </tr>
            </table>
            <h1 style="text-align:right;color: #7d1011;font-size: 34px;margin-top:90px;">PURCHASE ORDER</h1>
          </div>
        </div>
        <table>
          <thead>
            <tr>
              <td>
                <div class="page-header-space"></div>
              </td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div class="row">
                  <div class="col-xs-6">
                    <table style="margin-bottom: 10px;">
                      <tr>
                        <td style="padding-right:10px;font-weight: bold;">REFRENCE #</td>
                        <td>{{referenceNumber}}</td>
                      </tr>
                      <tr>
                        <td style="padding-right:10px;font-weight: bold;">EXPECTED DATE</td>
                        <td>{{expectedDate | dateFormat}}</td>
                      </tr>
                    </table>
                  </div>
                  <div class="col-xs-6">
                    <table>
                      <tr>
                        <td style="padding-right:10px;font-weight: bold;">EMAIL</td>
                        <td>{{companyEmail}}</td>
                      </tr>
                      <tr>
                        <td style="padding-right:10px;font-weight: bold;">TRN #</td>
                        <td>{{companyTRN}}</td>
                      </tr>
                    </table>

                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12">
                    <b-table-simple bordered>
                      <b-thead head-variant="dark">
                        <b-tr class="bg-prime"  style="text-transform:uppercase;">
                          <b-th>
                            Vendor Details
                          </b-th>
                          <b-th>Bill To
                          </b-th>
                          <b-th>Ship To</b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody>
                        <b-tr variant="info">
                          <b-td>{{vendorDetails.supplier_name}}<br/>
                            {{vendorDetails.supplier_address}}<br/>
                            {{vendorDetails.supplier_city}} P.O Box: {{vendorDetails.supplier_po}}<br/>
                            {{vendorDetails.supplier_country}}<br/>
                            Phone: {{vendorDetails.supplier_phone}}<br/>
                            Attn: {{supplierContact}}
                          </b-td>
                          <b-td>
                            {{companyName}}<br/>
                            P.O Box: {{companyPO}}
                            {{companyAddress}}<br/>
                            {{companyCity}}<br/>
                            {{companyCountry}}</b-td>
                          <b-td>
                            {{deliveryDetails.site_name}}<br/>
                            {{deliveryDetails.site_address}}<br/>
                            {{deliveryDetails.site_city}}<br/>
                            {{deliveryDetails.site_country}}<br/>
                            Phone: {{siteContactNo}}<br/>
                            Attn: {{siteContactPerson}}
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                    <b-table-simple bordered>
                      <b-thead head-variant="dark">
                        <b-tr class="bg-prime" style="text-transform:uppercase;">
                          <b-th>
                            Payment Terms
                          </b-th>
                          <b-th>Currency
                          </b-th>
                          <b-th>Delivery Date</b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody>
                        <b-tr>
                          <b-td>
                            {{paymentTerm.term_name}}
                          </b-td>
                          <b-td>                  
                            {{currency}}</b-td>
                          <b-td>{{expectedDate | dateFormat}}
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                    <b-table-simple bordered>
                      <b-thead head-variant="dark">
                        <b-tr class="bg-prime" style="text-transform:uppercase;">
                          <b-th>
                            S.No
                          </b-th>
                          <b-th>Item Details
                          </b-th>
                          <b-th>Qty</b-th>
                          <b-th>Unit Price</b-th>
                          <b-th>Sub Total</b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody>
                        <b-tr v-for="(item, k) in cartItems" :key="k">
                          <b-td>{{k + 1}}</b-td>
                          <b-td>
                            {{item.product_name}}
                          </b-td>
                          <b-td>                  
                            {{item.quantity}}</b-td>
                          <b-td>{{item.price | amount}}
                          </b-td>
                          <b-td>{{(item.sub_total) | amount}}
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td>               
                          </b-td>
                          <b-td colspan="3" style="text-transform:uppercase;font-weight: bold;text-align: right;">
                          Total Amount Excl. Tax</b-td>
                          <b-td style="font-weight: bold;">{{cartTotal | amount}}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                    <b-table-simple bordered>
                      <b-thead head-variant="dark">
                        <b-tr class="bg-prime" style="text-transform:uppercase;">
                          <b-th>
                            VAT Rate
                          </b-th>
                          <b-th>Amount Excl. VAT
                          </b-th>
                          <b-th>VAT Amount</b-th>
                          <b-th>Total Amount</b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody>
                        <b-tr>
                          <b-td>5%</b-td>
                          <b-td>
                            {{cartTotal | amount}}
                          </b-td>
                          <b-td>                  
                            {{taxAmount | amount}}</b-td>
                          <b-td>{{totalAmount | amount}}
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td>               
                          </b-td>
                          <b-td colspan="2" style="text-transform:uppercase;font-weight: bold;text-align: right;">
                          Total Amount</b-td>
                          <b-td style="font-weight: bold;">{{totalAmount | amount}}</b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                    <p style="font-weight:bold;margin-bottom: 0px;">Amount in words</p>
                    <p style="text-transform: capitalize; margin-bottom: 8px;">{{amountWords}}</p>
                    <b-table-simple bordered>
                      <b-thead>
                        <b-tr class="bg-prime" style="text-transform:uppercase;">
                          <b-th>
                            Notes for Vendor
                          </b-th>
                        </b-tr>
                      </b-thead>
                      <b-tbody>
                        <b-tr>
                          <b-td>
                            {{remarks}}
                          </b-td>
                        </b-tr>
                      </b-tbody>
                    </b-table-simple>
                    <table>
                      <tr>
                        <td colspan="5" hieght="5" style="height:5px;"></td>
                      </tr>
                      <tr>
                        <td width="122" style="width:122px;"></td>
                        <td width="300" style="width:300px;"></td>
                        <td width="122" style="width:122px;text-align: center;"></td>
                        <td width="300" style="width:300px;text-align: center;"></td>
                        <td width="122" style="width:122px;text-align: center;">
                          <img v-if="lpoStatus === 1" width="122" style="width:122px" src="../../public/static/img/sign.jpeg"/>
                        </td>
                      </tr>
                      <tr>
                        <td width="122" style="width:122px;text-align: center;">Requested By</td>
                        <td width="300" style="width:300px;"></td>
                        <td width="122" style="width:122px;text-align: center;">Prepared By</td>
                        <td width="300" style="width:300px;"></td>
                        <td width="122" style="width:122px;text-align: center;">Approved By</td>
                      </tr>
                    </table>
                    <p style="font-weight:bold;margin-bottom: 20px;margin-top:10px">Approved on behalf of {{companyName}}</p>
                    <p style="text-align:right;">
                      <img height="60" style="height: 60px;" src="../../public/static/img/tuv_logo.png"/> 
                      <img height="60" style="height: 60px;" src="../../public/static/img/eiac_logo.png"/>
                      <img height="60" style="height: 60px;" src="../../public/static/img/oshad_logo.png"/>
                    </p>
                    <l-p-o-terms/>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <td>
                <div class="page-footer-space"></div>
              </td>
            </tr>
          </tfoot>
        </table>
        <div class="page-footer">
          <p style="text-align:center">{{companyName}} | {{companyAddress}} {{companyCity}} | P.O Box: {{companyPO}} | Phone: {{companyPhone}}</p>
        </div>
      </div>
      -->
      </div>
      <div class="modal-footer">
        <div class="row">
          <div class="col-md-3">
            <p style="text-align:left;line-height: 2;">
              <input type="checkbox" v-model="showTerms" style="margin-bottom:3px;"/>
            Include Terms and Conditions
          </p>
          </div>
          <div class="col-md-3">
            <p style="text-align:left;line-height: 2;">
              <input type="checkbox" v-model="includeVAT" style="margin-bottom:3px;"/>
            Include VAT
          </p>
          </div>
        <div class="col-md-6" style="text-align: right">        
            
          <button
          @click="generatePDF()"
            id="btn_save"
            class="btn btn-success  text-center  "
          >
            Download PDF
          </button>
          <!--
          <button
          @click="printLPO()"
            id="btn_save"
            class="btn btn-success  text-center  "
          >
            Print LPO
          </button>
          -->
          <a
            v-on:click="$emit('hide-form')"
            class="btn btn-danger  text-center  "
          >
            Close
          </a>
        </div>

        </div>
      </div>
      
  </section>
</template>

<script>
import api from "../api";
import config from "../config";
// import { BTableSimple, BThead, BTbody, BTr, BTh, BTd } from "bootstrap-vue";
import VueHtml2pdf from 'vue-html2pdf'
// import LPOTerms from './LPOTerms.vue'
import PurchaseOrder from './PurchaseOrder.vue'
var converter = require('number-to-words');

export default {
  props: ["purchaseId", "item"],
  name: "ViewPurchaseOrder",
  data() {
    return {
      htmlToPdfOptions: {margin:[10,0,10,0],
        filename: 'LPO-' + this.item.purchase_id + '.pdf',
        pagebreak: { mode: ['css', 'legacy'], avoid: ['tr', 'img', 'p'] },
        image: {
        type: 'jpeg', 
        quality: 1
      },
      html2canvas: {
        dpi: 192,
        scale:4,
        letterRendering: true,
        useCORS: true
      },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
      },
      companyEmail: config.companyEmail,
      companyTRN: config.companyTRN,
      companyName: config.companyName,
      companyAddress: config.companyAddress,
      companyCity: config.companyCity,
      companyCountry: config.companyCountry,
      companyPO: config.companyPO,
      companyPhone: config.companyPhone,
      saveCat: false,
      itemId: this.item.purchase_id,
      orderDate: this.item.order_date,
      expectedDate: this.item.expected_date,
      currency: this.item.currency,
      referenceNumber: this.item.reference_number,
      supplierContact: this.item.supplier_contact_person,
      siteContactPerson: this.item.site_contact_person,
      siteContactNo: this.item.site_contact_number,
      supplier: {supplier_id: this.item.supplier_id, supplier_name: this.item.supplier_name},
      project: {project_id: this.item.project_id, project_name: this.item.project_name},
      location: {site_id: this.item.site_id, site_name: this.item.site_name},
      paymentTerm: { term_id: this.item.payment_term_id, term_name: this.item.payment_term_name},
      requestedBy: this.item.requested_by,
      remarks: this.item.remarks,
      supplierList: [],
      productList: [],
      paymentList: [],
      projectList: [],
      locationList: [],
      productMaster: [],
      cartItems: [],
      errors : [],
      loading: false,
      lpoStatus: this.item.order_status,
      showTerms: false,
      includeVAT: true
    };
  },
  components: {
    // LPOTerms,
    PurchaseOrder,
    VueHtml2pdf,
    // BTableSimple, BTd, BThead, BTbody, BTr, BTh
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    amount: function (value) {
      if (!value) return ''
      value = value.toString()
      return Number(value).toFixed(2)
    },
    dateFormat: function(date) {
      var options = {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
      };
      var formatdate = new Date(date);
      var dateformat = formatdate.toLocaleDateString("en-US", options);
      return dateformat;
    }
  },
  computed: {
    amountWords: function () {
      let amount = 'AED ';
      const total = Number(this.totalAmount).toFixed(2);
      console.log('Total:', total);
      const aedPart = Math.floor(total);
      const filsPart = parseInt(((total % 1) * 100).toFixed(2));
      amount = amount + converter.toWords(aedPart);
      if (filsPart) {
        console.log(filsPart)
        const fils = converter.toWords(filsPart);
        amount += ' And Fils ' + fils;
      }
      return amount + ' Only';
    },
    vendorDetails: function() {
      const vendor = {
        supplier_name: this.item && this.item.supplier_name,
        supplier_address: this.item && this.item.supplier_address,
        supplier_city: this.item && this.item.supplier_city,
        supplier_po: this.item && this.item.supplier_po,
        supplier_country: this.item && this.item.supplier_country,
        supplier_phone: this.item && this.item.supplier_phone
      }
      return vendor
    },
    deliveryDetails: function() {
      const location = {
        site_name: this.item && this.item.site_name,
        sie_address: this.item && this.item.site_address,
        site_city: this.item && this.item.site_cisty,
        site_country: this.item && this.item.site_country
      }
      return location;
    },
    lpoNumber: function () {
      return 'LPO-' + this.item.purchase_id;
    },
    cartTotal: function () {
      var total = this.cartItems.reduce((acc, item) => acc + item.sub_total, 0)
      return total
    },
    taxAmount: function () {
      const total = this.cartTotal * 0.05;
      return total
    },
    totalAmount: function () {
      const total = this.cartTotal + this.taxAmount;
      return total;
    },
    cartProducts: function () {
      var productList = this.cartItems.filter(function (obj) {
        return obj.product_id !== ''
      })
      return productList
    },
    getStatus: function () {
      if (this.itemId) {
        if (this.lpoStatus < 0) {
          return 'Rejected'
        } else if (this.lpoStatus > 0) {
          return 'Approved'
        } else {
          return 'Waiting for Approval'
        }
      } else {
        return 'Draft'
      }
    }
  },
  methods: {
    generatePDF() {
      this.$refs.html2Pdf.generatePdf();
    },
    printLPO: function () {
      // Get HTML to print from element
      const prtHtml = document.getElementById('print').innerHTML;

      // Get all stylesheets HTML
      let stylesHtml = '';
      for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
        stylesHtml += node.outerHTML;
      }

      // Open the print window
      const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

      WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            ${stylesHtml}
          </head>
          <body>
            ${prtHtml}
          </body>
        </html>`);

      WinPrint.document.close();
      setTimeout(function() {
      WinPrint.focus();
      WinPrint.print();
      WinPrint.close();
      }, 250);
    },
    getPurchase: function() {
      var purchase_id = this.$props.purchaseId;
        (this.cartItems = []),
        (this.orderDate = ""),
        (this.expectedDate = ""),
        (this.currency= ""),
        (this.referenceNumber=""),
        (this.supplierContact=""),
        (this.siteContactPerson=""),
        (this.siteContactNo=""),
        (this.supplier=""),
        (this.project=""),
        (this.location=""),
        (this.paymentTerm=""),
        (this.requestedBy=""),
        (this.remarks=""),
        (this.itemId = 0);
      if (purchase_id > 0) {
        this.itemId = purchase_id;    
        const getItem = {
          filter: {
            purchase_id: this.itemId,
          },
        };
        api
          .request("post", "GeneralApis/get_purchases", getItem)
          .then((response) => {
            var data = response.data;
            if (data.errorcode) {
              this.response = data.errormessage;
              return;
            } else {
              const purchaseList = data.purchaseList[0];
              const cartList = data.cartList;
              this.orderDate = purchaseList.order_date;
              this.expectedDate = purchaseList.expected_date;
              this.currency = purchaseList.currency;
              this.referenceNumber = purchaseList.reference_number;
              this.supplierContact = purchaseList.supplier_contact_person;
              this.siteContactPerson = purchaseList.site_contact_person;
              this.siteContactNo = purchaseList.site_contact_number;
              this.requestedBy = purchaseList.requested_by;
              this.remarks = purchaseList.remarks;
              this.lpoStatus = purchaseList.order_status;
              cartList.forEach(item => {
                this.cartItems.push({
                  product_id: item.product_id,
                  quantity: item.quantity,
                  uom: item.uom_name,
                  price: item.unit_price,
                  sub_total: parseFloat(item.quantity) * parseFloat(item.unit_price),
                  product_name: item.product_name
                })
              });
            }
          });
      }
    },
  },
  mounted() {
    this.getPurchase();
  },
};
</script>

<style scoped>
.qty-cell{
  width: 50px;
}
#print{
  max-height: 80vh;
  overflow-y: auto;
}
.page-header{
  border-bottom: 1px solid #cccccc;
}
.page-footer{
  border-top: 1px solid #cccccc; 
}
   .bg-prime, .bg-prime td, .bg-prime th{
    background-color: #7d1011 !important;
    color: #ffffff !important;
   }
table{
  margin-bottom: 10px;
}
@page {
  margin: 10mm
}
@media print {   
   body {
    margin: 0;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
    color: #000000;
  }
  h1 {
    color: #7d1011 !important;
  }
   .bg-gray, .bg-gray td, .bg-gray th{
    background-color: #777777 !important;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
   }
   .bg-prime, .bg-prime td, .bg-prime th{
    background-color: #7d1011 !important;
    color: #ffffff !important;
    -webkit-print-color-adjust: exact;
    color-adjust: exact;
   }
.page-header, .page-header-space {
  height: 165px;
}
.page-header {
  height: 150px;
  position: fixed;
  top: 0mm;
  width: 100%;
  margin: 0;
  border-bottom: 1px solid #cccccc;
}
.page-footer, .page-footer-space {
  height: 50px;

}

.page-footer {
  height: 30px;
  position: fixed;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #cccccc;
}
   thead {display: table-header-group;} 
   tfoot {display: table-footer-group;}
   
   button {display: none;}
}
</style>